// extracted by mini-css-extract-plugin
export default {"modal":"style_modal__5QTSO","loader":"style_loader__r8CjX"};